import component from './select-config.vue';

export default component;